/* 
 * Export component file to be used on project
*/

import FreeTextInput from './FreeTextInput.js';
export default FreeTextInput;
